import { Link } from "react-router-dom";

// A5 (auditoría V2): página real de términos enlazada desde el login.
// BORRADOR honesto pendiente de revisión de Jorge — los huecos legales están
// marcados [PENDIENTE JORGE: …] a propósito; no inventar datos ahí.
// Guard §3: NADA aquí afirma ni insinúa emisión certificada/VeriFactu.

function Placeholder({ children }) {
  return (
    <span className="bg-amber-100 text-amber-900 px-1 rounded text-sm font-medium">
      [PENDIENTE JORGE: {children}]
    </span>
  );
}

export default function LegalTerms() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white border border-slate-200 rounded-lg p-8 space-y-6">
        <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded-md px-4 py-3 text-sm">
          <strong>Borrador pendiente de revisión legal.</strong> Este documento
          es una versión de trabajo para la beta privada y será revisado antes
          de cualquier apertura comercial.
        </div>

        <div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">
            Términos de servicio
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Última actualización: julio de 2026 (borrador)
          </p>
        </div>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">1. Qué es LiquidArc</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            LiquidArc es una herramienta de gestión administrativa, contabilidad
            y tesorería pensada para autónomos y pequeñas empresas de servicios
            en España. Permite registrar facturas emitidas y recibidas, importar
            y conciliar movimientos bancarios, llevar presupuestos y obtener una
            visión de tesorería del negocio.
          </p>
          <p className="text-sm text-slate-700 leading-relaxed">
            El servicio lo presta <Placeholder>titular legal — nombre o razón
            social, NIF y domicilio</Placeholder> (en adelante, "el titular").
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">2. Lo que LiquidArc no es</h2>
          <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
            <li>
              <strong>No es una asesoría fiscal ni contable.</strong> Los
              cálculos fiscales que muestra la aplicación (IVA a apartar,
              estimaciones de cuota o de impuestos) son orientativos y no
              sustituyen el criterio de tu gestoría o asesoría, que es quien
              presenta tus declaraciones.
            </li>
            <li>
              <strong>No presenta impuestos ante la AEAT</strong> ni genera
              declaraciones oficiales. Los exports (por ejemplo, el "Cierre de
              trimestre") son material de trabajo para ti o tu asesoría.
            </li>
            <li>
              Durante la beta, LiquidArc no emite facturas mediante sistemas de
              facturación certificados. Si tu actividad requiere requisitos
              específicos de facturación, consúltalo con tu asesoría.
            </li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">3. Beta privada por invitación</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            LiquidArc se encuentra en fase beta con acceso por invitación y sin
            coste. En esta fase el servicio se presta "tal cual", sin
            compromisos de disponibilidad ni de conservación de funcionalidades
            concretas, aunque trabajamos para que sea estable y avisaremos de
            los cambios relevantes con antelación razonable.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">4. Tu cuenta y tus obligaciones</h2>
          <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
            <li>Eres responsable de la confidencialidad de tus credenciales.</li>
            <li>
              Te comprometes a introducir información veraz y a usar el
              servicio solo para la gestión de tu propia actividad económica.
            </li>
            <li>
              Eres responsable de los datos de terceros (clientes, proveedores)
              que introduzcas, en los términos de la{" "}
              <Link to="/privacidad" className="text-blue-600 underline">
                política de privacidad
              </Link>.
            </li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">5. Tus datos y tu salida</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            Tus datos son tuyos. Puedes exportar tu información (facturas,
            movimientos, exports Excel) desde la propia aplicación y solicitar
            la eliminación completa de tu cuenta escribiendo a{" "}
            <a href="mailto:info@nexobound.com" className="text-blue-600 underline">
              info@nexobound.com
            </a>.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">6. Responsabilidad</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            El titular responderá de los daños causados por dolo o negligencia
            grave. En la medida en que la ley lo permita, el titular no asume
            responsabilidad por decisiones fiscales, contables o de negocio
            tomadas a partir de la información mostrada por la aplicación sin
            la validación de un profesional. <Placeholder>revisar esta
            cláusula con asesoría legal antes de cobrar por el servicio</Placeholder>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">7. Cambios y ley aplicable</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            Podremos actualizar estos términos; si el cambio es sustancial, lo
            comunicaremos por email o dentro de la aplicación. Estos términos se
            rigen por la legislación española.
          </p>
        </section>

        <div className="pt-4 border-t border-slate-200 flex items-center justify-between">
          <Link to="/login" className="text-sm text-blue-600 underline">
            ← Volver al acceso
          </Link>
          <Link to="/privacidad" className="text-sm text-blue-600 underline">
            Política de privacidad →
          </Link>
        </div>
      </div>
    </div>
  );
}
